import { render, staticRenderFns } from "./WTextarea.vue?vue&type=template&id=5cf3b498&scoped=true"
import script from "./WTextarea.vue?vue&type=script&lang=js"
export * from "./WTextarea.vue?vue&type=script&lang=js"
import style0 from "./WTextarea.vue?vue&type=style&index=0&id=5cf3b498&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf3b498",
  null
  
)

export default component.exports